import SetupContent from './SetupContent';
import SetupHeader from './SetupHeader';
import SetupLayout from './SetupLayout';

const SetupPage = () => (
  <SetupLayout>
    <SetupHeader />
    <SetupContent />
  </SetupLayout>
);

export default SetupPage;
